import "./Root.css";

export function Root() {
  return (
    <div className="overflow-hidden h-screen px-4 py-16 mx-auto w-full flex flex-col justify-center items-center md:px-24 lg:px-8 lg:py-20">
      <div className="flex flex-col items-center justify-between w-full max-w-6xl mx-auto mb-10 lg:flex-row h-full">
        <div
          className="mb-16 lg:mb-0 lg:pr-5 order-2 lg:order-1 px-6 lg:px-0"
          style={{ zIndex: 2 }}
        >
          <div className="max-w-xl mb-6 h-full">
            <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold tracking-tight text-gray-50 sm:text-4xl sm:leading-none">
              Wisdom - Daily Quotes
            </h2>

            <p className="text-base text-gray-50 md:text-lg">
              Wisdom is a mobile app that delivers quotes to your daily life. It
              helps you get through each day with life lessons and thoughts from
              everyone around the globe who has been successful in their own
              way.
            </p>

            {/* <h3 className="text-2xl font-bold mt-6 mb-8 underline tracking-tight text-gray-50 md:text-2xl">
              Free till February 12th
              </h3> */}

            <p className="text-base mt-6 mb-8 tracking-tight text-gray-50">
              To get a discount please contact: <a href="mailto:hi.wisdomapp@gmail.com"
              style={{
                fontWeight: 600,
                borderBottom: '1px solid #7dd3fc'
              }}
              >hi.wisdomapp@gmail.com</a>
            </p>


              <div className="flex items-center space-x-3">
            <a
              href="https://apps.apple.com/us/app/wisdom-daily-quotes/id1665478736"
              className="w-48 transition duration-300 hover:shadow-lg"
            >
              <img
                src="/images/app-store.png"
                alt=""
                className="object-cover object-top w-full h-auto mx-auto"
                draggable="false"
              />
            </a>
          </div>
          </div>
         
        </div>
        <div className="relative h-full flex items-center justify-center lg:w-1/2 order-1">
          <picture
            className="hidden lg:block"
            style={{
              position: "absolute",
              left: "20px",
              top: "calc(50% - 350px)",
              width: "150%",
            }}
          >
            <source media="(min-width:650px)" srcSet="/images/Website.png" />
            <img
              src="/images/Website.mobile.png"
              alt="Flowers"
              style={{ width: "auto" }}
            />
          </picture>
          <picture className="lg:hidden">
            <source media="(min-width:650px)" srcSet="/images/Website.png" />
            <img
              src="/images/Website.mobile.png"
              alt="Flowers"
              style={{ width: "auto" }}
            />
          </picture>
        </div>
      </div>
    </div>
  );
}
